/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {ListDefaultActionsComponent} from '../common/directives/list-default-actions.component';
import {ReportRequesterComponent} from './widget/report-requester.component';
import {PERMISSIONS} from '../../components/auth/auth-constants';
import {ReportRoutePageComponent} from './report-route-page.component';



export function reportStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
states.add('app.rep.reports', {
          url: '/reports',
          resolve: {
            listNewStateName: function() {
              return 'app.rep.reports.new';
            },
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasNetwork(PERMISSIONS.manageReportTemplates.apiKey)
                && !LocalUserPermissions.hasAny(PERMISSIONS.runReports.apiKey);
            }
          },
          views: {
            'content@app': {component: ReportRoutePageComponent, bindings: {readOnly: 'readOnly'}},
            'context@app': {
              component: ListDefaultActionsComponent,
              bindings: {readOnly: 'readOnly', newStateName: 'listNewStateName'}
            },
            'title@app': stateTitleView()
          },
          data: {
            title: "report.plural"
          }
        }).add('app.rep.reports.new', {
          url: '/new',
          views: {
            'content@app': {
              component: ReportRequesterComponent
            },
            'context@app': {},
            'title@app': stateTitleView()
          },
          data: {
            title: 'Request a Report'
          }
        });
  return states.build();
}
